/**
 * Atalho "Não receber disparos em massa" do drawer do contato (Etapa 4 — A2).
 * Componente compartilhado: entra no ContactDetailsDrawer e vale para os 4
 * canais de graça. A chave do contato viaja OPACA (instagram:/messenger:
 * intactas) — a canonização de 9º dígito é toda do backend (/api/blocklist).
 */
import React, { useCallback, useEffect, useState } from 'react';
import { Ban, Loader2 } from 'lucide-react';
import blocklistService from '../../services/global/blocklistService';

const BlocklistToggle = ({ contactKey, colors }) => {
  const [blocked, setBlocked] = useState(null); // null = carregando
  const [enabled, setEnabled] = useState(false);
  const [busy, setBusy] = useState(false);

  const refresh = useCallback(async () => {
    if (!contactKey) return;
    try {
      const res = await blocklistService.check(contactKey);
      setBlocked(!!res?.data?.blocked);
      setEnabled(!!res?.enabled);
    } catch (e) {
      setBlocked(false);
    }
  }, [contactKey]);

  useEffect(() => { setBlocked(null); refresh(); }, [refresh]);

  const toggle = async () => {
    if (busy || blocked === null) return;
    if (!enabled && !blocked) return; // escrita indisponível
    setBusy(true);
    try {
      if (blocked) await blocklistService.remove(contactKey);
      else await blocklistService.add(contactKey, 'Bloqueado pelo drawer do contato');
      await refresh();
    } catch (e) {
      /* mantém o estado atual; o check do refresh conserta */
    } finally {
      setBusy(false);
    }
  };

  if (!contactKey) return null;

  const inativo = !enabled && !blocked;
  return (
    <div style={{
      display: 'flex', alignItems: 'center', gap: 8,
      padding: '8px 10px', borderRadius: 8,
      border: `1px solid ${blocked ? '#ef444440' : colors.borderColor}`,
      backgroundColor: blocked ? '#ef44440d' : 'transparent',
    }}>
      <Ban size={14} color={blocked ? '#ef4444' : colors.textTertiary} />
      <span style={{ flex: 1, fontSize: 12.5, color: colors.textPrimary }}>
        Não receber disparos em massa
      </span>
      {blocked === null || busy ? (
        <Loader2 size={13} color={colors.textTertiary}
          style={{ animation: 'spin 1s linear infinite' }} />
      ) : (
        <button
          type="button"
          onClick={toggle}
          disabled={inativo}
          title={inativo
            ? 'A escrita da lista de bloqueio ainda não está liberada neste ambiente'
            : blocked
              ? 'Voltar a receber disparos em massa'
              : 'Campanhas, fluxos e disparos por etapa passam a pular este contato'}
          style={{
            width: 36, height: 20, borderRadius: 999, border: 'none',
            cursor: inativo ? 'default' : 'pointer', position: 'relative',
            background: blocked ? '#ef4444' : colors.borderColor,
            opacity: inativo ? 0.5 : 1, padding: 0, flexShrink: 0,
          }}
        >
          <span style={{
            position: 'absolute', top: 2, left: blocked ? 18 : 2,
            width: 16, height: 16, borderRadius: '50%', background: '#fff',
            transition: 'left 150ms ease',
          }} />
        </button>
      )}
    </div>
  );
};

export default BlocklistToggle;
